import { useWidgetConfig } from '../providers/WidgetProvider/WidgetProvider.js';
export function useInternalWalletProvider(hasExternalContext) {
    const { walletConfig } = useWidgetConfig();
    return walletConfig?.forceInternalWalletManagement || !hasExternalContext;
}
//# sourceMappingURL=useInternalWalletProvider.js.map